__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "remote_module_render_0_1_0";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "6.3.2", () => (Promise.all([__webpack_require__.e(628), __webpack_require__.e(884), __webpack_require__.e(7)]).then(() => (() => (__webpack_require__(8628))))));
			register("@kne/axios-fetch", "1.2.2", () => (Promise.all([__webpack_require__.e(312), __webpack_require__.e(946), __webpack_require__.e(544)]).then(() => (() => (__webpack_require__(4312))))));
			register("@kne/ensure-slash", "0.1.0", () => (__webpack_require__.e(24).then(() => (() => (__webpack_require__(5024))))));
			register("@kne/react-fetch", "1.5.5", () => (Promise.all([__webpack_require__.e(588), __webpack_require__.e(201), __webpack_require__.e(884), __webpack_require__.e(163)]).then(() => (() => (__webpack_require__(3201))))));
			register("@kne/remote-loader", "1.4.6", () => (Promise.all([__webpack_require__.e(588), __webpack_require__.e(601), __webpack_require__.e(884), __webpack_require__.e(202), __webpack_require__.e(782)]).then(() => (() => (__webpack_require__(8601))))));
			register("@kne/use-ref-callback", "0.1.3", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(400)]).then(() => (() => (__webpack_require__(1400))))));
			register("antd", "5.29.3", () => (Promise.all([__webpack_require__.e(260), __webpack_require__.e(884), __webpack_require__.e(458), __webpack_require__.e(388)]).then(() => (() => (__webpack_require__(7260))))));
			register("axios", "1.18.1", () => (Promise.all([__webpack_require__.e(774), __webpack_require__.e(401)]).then(() => (() => (__webpack_require__(3774))))));
			register("dayjs", "1.11.21", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(446))))));
			register("plantuml-encoder", "1.4.0", () => (__webpack_require__.e(289).then(() => (() => (__webpack_require__(2289))))));
			register("qs", "6.15.3", () => (Promise.all([__webpack_require__.e(908), __webpack_require__.e(634)]).then(() => (() => (__webpack_require__(2908))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(7950))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};